import styled, { css } from 'styled-components';

interface ContainerProps {
  route: string;
}

export const Container = styled.div<ContainerProps>`
  position: absolute;
  z-index: 1;

  .bubble {
    position: absolute;

    &.bubble1 {
      width: 354.52px;
      height: auto;
      ${({ route }) =>
        route === 'contact'
          ? css`
              top: 35em;
              left: 48em;
              transform: rotate(-92deg);
            `
          : css`
              top: 10em;
              left: 58em;

              @media (max-width: 1366px) {
                top: -1em;
                left: 47em;
              }

              @media (max-width: 1024px) {
                top: 5em;
                left: 49em;
              }
            `}
      right: 0;
    }

    &.bubble2 {
      width: 250px;
      height: auto;
      top: 4em;
      right: 0;
      left: 55em;

      @media (max-width: 1366px) {
        top: -7em;
        left: 44em;
      }
    }

    &.bubble3 {
      width: 120px;
      height: auto;
      top: 29em;
      right: 0;
      left: 55em;

      @media (max-width: 1366px) {
        top: 18em;
        left: 44em;
      }
    }

    &.bubble4 {
      width: 300px;
      height: auto;
      top: 8em;
      right: 0;
      left: -22em;
    }

    &.bubble5 {
      width: 320px;
      height: auto;
      top: -12em;
      right: 0;
      left: 10em;

      @media (max-width: 1366px) {
        top: -15em;
      }
    }

    &.bubble6 {
      width: 70px;
      height: auto;
      top: 18em;
      right: 0;
      left: 80em;

      @media (max-width: 1366px) {
        top: 7em;
        left: 69em;
      }
    }

    &.bubble7 {
      width: 200px;
      height: auto;
      top: -9em;
      right: 0;
      left: 86em;
    }
  }
`;
